<template>
    <div id="entry-header-modules" class="eh" :data-scrolled="scrolled">
        <div
            class="eh__content c c--content--pad r r--justify-space-between r--row-always r--halign-center pad--h v--5">
            <div class="eh__content__home-link">

            </div>
            <div class="eh__content__title">
                <span class="type--pre-header type--pre-header--bold">{{ title }}</span>
            </div>
            <div class="eh__content__logout">
                <button @click="$emit('close')" class="icon icon--close">
                    <Icon name="close" />
                </button>
            </div>
        </div>
        <div class="eh__bg"></div>
    </div>
</template>

<script>
import Icon from '@c/Icon.vue';
export default {
    components: {
        Icon,
    },
    data() {
        return {

        }
    },
    props: {
        title: String,
        scrolled: Boolean,
    },
    computed: {
        titleAdjusted() {
            let returned = "";

            switch (this.title) {
                case "help":
                    returned = "Crave/Slip";
                    break;
                case "tasks":
                    returned = "My Tasks";
                    break;
                case "plan":
                    returned = "My Plan";
                    break;
                default:
                    returned = "";
                    break;
            }
            return returned;
        }
    },
}
</script>

<style lang="scss" scoped>
.eh__content__title {
    opacity: 0;
    transition: all 0.15s;
}
.eh {
    &[data-scrolled="true"] {
        .eh__content__title {
            opacity: 1;
        }
    }
}
</style>